<template>
  <div class="row-cols-lg-2" v-if="authenticated">
    <b-row no-gutters>
      <b-col class="d-block p-2 bg-mdh text-white">
        Facility <em v-if="!hideSelectOne">(select one)</em>
      </b-col>
      <b-col>
        <b-form-select v-if="!isPickedFacility"
                       id="facilitySelect"
                       aria-label="facilitySelect"
                       label-field="facilitySelect"
                       v-model="selectedFacility"
                       @input="updateValue"
                       @change="updateStore"
                       disabled-field="enabled"
        >
          <template #first @click="updateStore">
            <b-form-select-option value="" disabled>-- Please select a facility --</b-form-select-option>
            <b-form-select-option v-for="facility in facilities" :key="facility.id" :value="facility"> {{facility.facilityName}}</b-form-select-option>
          </template>
        </b-form-select>
        <b-form-textarea v-if="isPickedFacility"
                         id="facilityDisplay"
                         aria-label="facilityDisplay"
                         label-field="facilityDisplay"
                         v-model="this.$store.state.selectedFacility.facilityName"
                         text-field="facilityDisplay"
                         value-field="facilityDisplay"
                         readonly
                         disabled
                         no-resize
        >
        </b-form-textarea>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  data: () => ({
    user: {
      id: "",
      iamId: "",
      emailAddress: "",
      org: "",
      primary: Boolean,

      userRole: [],
    },
    selectedFacility: '',
    facilities: [],
    pickedFacility: '',
  }),
  props: {
    isPickedFacility: Boolean,
    hideSelectOne: Boolean
  },

  created() {
    if (this.value != null) {
      this.updateValue(this.value)
    }
  },
  mounted() {
  },
  computed: {
    authenticated: function() {
      if (this.$keycloak) {
        this.getFacilities()
        return this.$keycloak.authenticated;
      } else {
        return false;
      }
    },
    id() {
      if (this.setId === null) {
        return _.uniqueId('selector')
      } else {
        return this.setId
      }
    },
  },
  methods: {
    getFacilities() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user`).then(response => {
        this.user = response.data
        if (this.user.org != null) {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/facilities/${this.user.emailAddress}`).then(response => {
            this.facilities = response.data
          })
        }
      })
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    updateStore() {
      this.$store.commit("UPDATE_STATE", this.selectedFacility)
      this.$emit('change')
    },
  },
}

</script>

<style scoped>

</style>
